<template>
  <div :class="['issue-badge-bar', levelClass]">
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { isBadgeLevelValue, normalizeBadgeLevel } from '@components/utils/normalizeBadgeLevel';

const props = defineProps({
  readyFor: {
    type: String,
    default: 'apprentice',
    validator: (value) => isBadgeLevelValue(value) && normalizeBadgeLevel(value) !== 'novice'
  }
});

const levelClass = computed(() => normalizeBadgeLevel(props.readyFor) || props.readyFor);
</script>

<style scoped>
.issue-badge-bar {
  height: 24px;
  width: 2px;
  content: "";
}
.issue-badge-bar.apprentice {
  background-color: #E58700;
}
.issue-badge-bar.proficient {
  background-color: #00B813;
}
.issue-badge-bar.coach {
  background-color: #00A3FF;
}
.issue-badge-bar.architect {
  background-color: #2E1EC1;
}
</style>